// EC-27 : Sub Task - 557 Cart Page 
// Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments.
import { productCarouselProductStyles } from "@WhiteCap/Overrides/Components/ProductCarouselProduct";
import { css } from "styled-components";

productCarouselProductStyles.productDescriptionStyles = {
	productDetailLink: {
		css: css`
			margin-bottom: 6px;
			span{
				font-size: 12px;
			}
		`,
    },
}
// End: Refactored dynamic CSS from CMS to code for consistent behavior across environments.